import React, { CSSProperties } from 'react';

import { StarSC } from './star.styled';

type TStarProps = {
  color: CSSProperties['color'];
  size?: CSSProperties['fontSize'];
  className?: string;
};

const Star: React.FC<TStarProps> = ({ color, className, size }: TStarProps) => (
  <StarSC className={className} color={color} size={size} />
);

export default Star;
